import {DefaultButton, FontSizes, FontWeights, PrimaryButton, SharedColors,} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import {Link, useOutletContext, useParams} from "react-router-dom";
import AddAgreementElement from "../Panel/AgreementElement/AddAgreementElement";
import InvoiceList from "../Lists/InvoiceList";
import AddVentureDocument from "../Panel/VentureDocument/AddVentureDocument";
import AgreementElementDataView from "./Venture/Agreement/AgreementElementDataView";
import {MoneyField} from "../Utilities/MoneyField";
import ProtocolPaymentList from "../Lists/ProtocolPaymentList";
import {useNetGross} from "../Utilities/NetGrossField";
import AgreementFiles from "./Venture/Agreement/AgreementFiles";
import InnerContent from "../Surfaces/InnerContent";

function AgreementProtocol() {
    const [user] = useContext(AuthContext);
    const [header, setHeader] = useState([]);
    const [elements, setElements] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [files, setFiles] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [payments, setPayments] = useState([]);

    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/agreement/protocol/${params.pid}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setHeader(data.addons[0]);
                    setFiles(data.files);
                    if (data.addons[0].id !== null) {
                        setElements(data.addons);
                    } else {
                        setElements([]);
                    }
                    setInvoices(data.invoices);
                })
                .catch(err => { console.log(err) })
        }
        async function fetchPayments() {
            await fetch(`/api/payment/${params.pid}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setPayments(data); })
                .catch(err => { console.log(err) })
        }

        fetchData();
        fetchPayments();
        return () => abortController.abort();
    }, [refresh, user.token]);

    const [addElement, setAddElement] = useState(false);
    const [addDocument, setAddDocument] = useState(false);

    const _generatePayments = () => {
        fetch(`/api/agreement/protocol/${params.pid}/generate_payment`, {
            method: "PUT",
            headers: {
                "Authorization": "Bearer " + user.token,
            },
        }).then(res => res.json())
            .then(json => {
                _refresh();
            })
            .catch(err => {
                console.log(err);
            });
    };

    const netGross = useNetGross();
    const context = useOutletContext();
    const actions = context?.actions ? context.actions : context;
    useEffect(() => {
        actions([
            {
                key: 'generatePayments',
                text: 'Generuj Płatności',
                iconProps: { iconName: 'PaymentCard' },
                onClick: () => _generatePayments()
            },
            {
                key: 'protocolReport',
                text: 'Raport',
                iconProps: { iconName: 'ReportDocument' },
                onClick: () => window.open(`/api/report/agreement/protocol/${params.pid}?auth=${user.token}`, '_blank')
            },
            {
                key: 'addElement',
                text: 'Przypisz Koszt',
                iconProps: { iconName: 'Assign' },
                onClick: () => setAddElement({agreement_protocol_id: params.pid})
            },
            {
                key: 'addDocument',
                text: 'Dodaj Plik',
                iconProps: { iconName: 'PageAdd' },
                onClick: () => setAddDocument({venture_id: params.id, agreement_protocol_id: params.pid})
            },
        ]);
        return actions;
    }, []);


    const paymentsColumns = [
        {
            key: 'protocol_number',
            name: 'Numer protokołu',
            ariaLabel: 'Numer protokołu',
            fieldName: 'protocol_number',
            minWidth: 100,
            isRowHeader: true,
            isResizable: true,
            onRender: (item) => {
                let color = SharedColors.cyanBlue10;
                if(item.completed) {
                    color = SharedColors.green10
                }
                return (
                    <span>
                        <PrimaryButton
                            text={item.protocol_number}
                            styles={{root: {backgroundColor: color, borderColor: color},
                            rootHovered: {backgroundColor: color, borderColor: color}}}
                        />

                        {item.retention_name ? <DefaultButton text={item.retention_name} styles={{root: {marginLeft:10}}}/> : ""}
                    </span>
                )
            }
        },
        {
            key: 'agreement_number',
            name: 'Numer umowy',
            ariaLabel: 'Numer umowy',
            fieldName: 'agreement_number',
            minWidth: 100,
            isResizable: true,
            onRender: (item) => (<Link to={`/venture/${item.venture_id}/cost/${item.agreement_id}`}><DefaultButton text={item.agreement_number} /></Link>)
        },
        {
            key: 'venture_name',
            name: 'Kontrakt',
            ariaLabel: 'Nazwa kontraktu',
            fieldName: 'venture_name',
            minWidth: 250,
            isResizable: false,
        },
        {
            key: 'contractor_name',
            name: 'Wykonawca',
            ariaLabel: 'Nazwa wykonawcy',
            fieldName: 'contractor_name',
            minWidth: 200,
            isResizable: false,
        },
        {
            key: 'created',
            name: 'Utworzono',
            ariaLabel: 'Utworzono',
            fieldName: 'created',
            minWidth: 120,
            isResizable: false,
        },
        {
            key: 'deadline',
            name: 'Termin',
            ariaLabel: 'Termin',
            fieldName: 'deadline',
            minWidth: 120,
            isResizable: false,
        },
        {
            key: 'value',
            name: 'Wartość',
            ariaLabel: 'Wartość',
            fieldName: 'value',
            minWidth: 120,
            isResizable: false,
            ...MoneyField()
        },
    ];

    const _refresh = () => setRefresh((prev) => prev + 1);
    const backTo = header?.venture_agreement_id ? `/venture/${params.id}/cost/${header.venture_agreement_id}` : '/cost';
    return (
        <InnerContent title={`Protokół ${header?.number}`} subtitle={header?.from} backTo={backTo}>

            <InvoiceList data={invoices} project={false} refresh={() => setRefresh(refresh + 1)} />
            <AgreementFiles items={files} />
            <AgreementElementDataView items={elements} refresh={() => setRefresh(refresh + 1)}
                                      total={header?.cost_net_value} netGross={netGross} showClear={true} showLeft={true}/>

            <h4 style={{ fontSize: FontSizes.size24, fontWeight: FontWeights.light }}>Płatności</h4>
            <ProtocolPaymentList refresh={()=>setRefresh(refresh+1)} columns={paymentsColumns} data={payments} cancel={true}/>

            <AddVentureDocument add={addDocument} dismissPanel={() => setAddDocument(false)}
                                onSuccess={() => setRefresh(refresh + 1)} />
            <AddAgreementElement add={addElement} onSuccess={() => setRefresh(refresh + 1)}
                                 dismissPanel={() => setAddElement(false)} />
        </InnerContent>
    );
}

export default AgreementProtocol;